import { AdvancedMarker, AdvancedMarkerAnchorPoint } from "@vis.gl/react-google-maps"
import { useTranslation } from "next-i18next"
import React from "react"

import StorePreviewCard from "@/components/LuggageStorage/Map/Interactive/StorePreviewCard/StorePreviewCard"
import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"

import LuggageStorePinImageSelected from "@bounce/marketing/src/assets/img/luggage-store-pin-selected.svg"
import LuggageStorePinImage from "@bounce/marketing/src/assets/img/luggage-store-pin.svg"

const Z_INDEX_SELECTED_STORE = 20
const Z_INDEX_DEFAULT = 1

interface StoreMarkerProps {
  store: NearbyStorageSpot
  isSelected: boolean
  onClick: (store: NearbyStorageSpot) => void
  onDismiss: () => void
  href: string
}

const StoreMarker = ({ store, isSelected, onClick, href }: StoreMarkerProps) => {
  const { t } = useTranslation()
  const markerZIndex = isSelected ? Z_INDEX_SELECTED_STORE : Z_INDEX_DEFAULT
  const LuggageStoragePin = isSelected ? LuggageStorePinImageSelected : LuggageStorePinImage

  return (
    <AdvancedMarker
      onClick={() => onClick(store)}
      position={{ lat: store.coordinates.latitude, lng: store.coordinates.longitude }}
      zIndex={markerZIndex}
      anchorPoint={AdvancedMarkerAnchorPoint.TOP_CENTER}>
      <div className="relative">
        <LuggageStoragePin alt={t("cmp.interactiveCityMap.pinAlt", "Bounce luggage storage pin marker")} />
        {isSelected && (
          <>
            <div className="absolute bottom-full left-1/2 -translate-x-1/2">
              <StorePreviewCard store={store} href={href} />
            </div>
          </>
        )}
      </div>
    </AdvancedMarker>
  )
}

export const MemoizedStoreMarker = React.memo(StoreMarker)
